module.exports = __webpack_public_path__ + "static/media/menuimg.5190afa6.png";